export default __webpack_public_path__ + "static/media/Dropup_black.e42f7c17.svg";